import { DashboardChartBox } from '../dashboard-chart-box.tsx'
import { useGetHitRateQuery } from '../../../../../apis/statistics/statistics-api.api.ts'
import ReactECharts from 'echarts-for-react'
import { DefaultLabelFormatterCallbackParams, EChartsOption } from 'echarts'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../../redux/hooks.ts'
import { selectDashboardInput } from '../../../../../redux/slices/dashboard-input.slice.ts'
import dayjs from 'dayjs'
import { selectTheme, selectThemeStyle } from '../../../../../features/setting/setting.slice.ts'
import { getEchartsTheme } from '../../../../../utils/helpers.ts'

interface HitRateChartProps {
  bookId: string
}

export const HitRateChart: React.FC<HitRateChartProps> = ({ bookId }) => {
  const { t } = useTranslation()
  const dashboardInput = useAppSelector(selectDashboardInput)
  const themeStyle = useAppSelector(selectThemeStyle)
  const colorTheme = useAppSelector(selectTheme)
  const echartsTheme = getEchartsTheme(colorTheme)
  const { data } = useGetHitRateQuery({
    bookId: bookId,
    startDate: dayjs(dashboardInput.dateRange[0]).format('YYYY-MM-DD'),
    endDate: dayjs(dashboardInput.dateRange[1]).format('YYYY-MM-DD'),
  })

  if (!data) return <></>

  const missRate = 1 - data.data
  const chartOption: EChartsOption = {
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        const input = params as DefaultLabelFormatterCallbackParams
        return `${input.name}: ${input.percent}%`
      },
    },
    legend: {
      orient: 'vertical',
      left: 'center',
      bottom: 'bottom',
      textStyle: {
        color: themeStyle.sumText,
      },
    },
    graphic: {
      type: 'text',
      left: 'center',
      top: 'center',
      style: {
        text: `${t('dashboard.hit_rate')}: ${(data.data * 100).toFixed(2)}%\n${t('dashboard.miss_rate')}: ${(
          missRate * 100
        ).toFixed(2)}%`,
        fill: themeStyle.sumText,
        fontSize: 16,
      },
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['60%', '70%'],
        data:
          data.data < 0
            ? [
              {
                value: missRate,
                name: t('dashboard.miss_rate'),
              },
            ]
            : [
              {
                value: data.data,
                name: t('dashboard.hit_rate'),
              },
              {
                value: missRate,
                name: t('dashboard.miss_rate'),
              },
            ],
        label: {
          show: false,
        },
      },
    ],
  }

  return (
    <DashboardChartBox title={t('dashboard.hit_rate')}>
      <ReactECharts option={chartOption} theme={echartsTheme.themeName} />
    </DashboardChartBox>
  )
}
